import React from 'react';
import ModuleRoute from 'holocron-module-route';
import { IndexRedirect } from '@americanexpress/one-app-router';
import setInitialTenancyLocale from './routerHooks/setInitialTenancyLocale';
import { moduleName } from './constants';

const childRoutes = (store) => [
  <ModuleRoute key={`${moduleName}-module-routes`} onEnter={setInitialTenancyLocale(store)}>
    <ModuleRoute moduleName="axp-myca-iguazu-config">
      <ModuleRoute moduleName="axp-account-analytics">
        <IndexRedirect to="dashboard" />
        <ModuleRoute moduleName="axp-myca-route-config" />
      </ModuleRoute>
    </ModuleRoute>
  </ModuleRoute>,
];

export default childRoutes;
